import React, {useRef} from "react";
import "./Box.css"
import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function Box(){

const box= useRef(null);
const h1 = useRef(null);

return(
    <div className="Box" ref={box}>
        <h1 ref={h1}>This is a box</h1>
    </div>
    )
}

export default Box;